export class AnagraficaAutocomplete {
    id: number;
    idProfilo: number;
    nome: number;
    cogonome: number;
    mail: string;
    tipologia: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/anagrafica-autocomplete.ts